import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
export function WhoIsFor() {
  const isFor = ['Ejecutivos y empresarios 40+ que necesitan mantener su ventaja competitiva.', 'Padres de familia que quieren energía real para jugar con sus hijos al final del día.', 'Hombres que sienten que han perdido su "chispa" y quieren recuperarla de forma natural.', 'Cualquier hombre que valore el rendimiento y la virilidad por encima de la estética superficial.'];
  const isNotFor = ['Jóvenes de 20 años que buscan "ponerse grandes" para la playa.', 'Personas que buscan una "pastilla mágica" sin cambiar un solo hábito diario.', 'Quienes no están dispuestos a invertir 15 minutos al día en su propio motor biológico.'];
  return <section className="bg-navy-800 py-20 px-4 sm:px-6 lg:px-8" data-id="element-138">
      <div className="max-w-6xl mx-auto" data-id="element-139">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-140">
          {/* Para quién ES */}
          <div className="bg-navy-900 rounded-2xl p-8 border border-green-500/20" data-id="element-141">
            <h3 className="font-playfair text-2xl font-bold text-white mb-8 flex items-center" data-id="element-142">
              <span className="bg-green-500/20 text-green-400 p-2 rounded-lg mr-3" data-id="element-143">
                <CheckIcon className="w-6 h-6" data-id="element-144" />
              </span>
              Para quién ES
            </h3>
            <ul className="space-y-6" data-id="element-145">
              {isFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-146">
                  <CheckIcon className="w-5 h-5 text-green-400 shrink-0 mt-1 mr-3" data-id="element-147" />
                  <span className="text-[#e0e0e0] leading-relaxed" data-id="element-148">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Para quién NO ES */}
          <div className="bg-navy-900 rounded-2xl p-8 border border-red-500/20" data-id="element-149">
            <h3 className="font-playfair text-2xl font-bold text-white mb-8 flex items-center" data-id="element-150">
              <span className="bg-red-500/20 text-red-400 p-2 rounded-lg mr-3" data-id="element-151">
                <XIcon className="w-6 h-6" data-id="element-152" />
              </span>
              Para quién NO ES
            </h3>
            <ul className="space-y-6" data-id="element-153">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start" data-id="element-154">
                  <XIcon className="w-5 h-5 text-red-400 shrink-0 mt-1 mr-3" data-id="element-155" />
                  <span className="text-[#e0e0e0] leading-relaxed" data-id="element-156">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}